<template>
    <main class="dashboard">
        <MainLayout
            :chartLoaded="true"
            @change-section="onSectionChange"
        />

        <div class="main-section underHeader">
            <div class="centered_div">
                <div class="analyst_assign_div">
                    <SimpleButton :buttonStyle="`linear-gradient(45deg, #f0f4ff, #fafdff)`" @click="asignarAnalistas"
                        class="button_analyst_assign">
                        <span class="assign_text">Asignación Analistas</span> <img :src="assign_logo"
                            class="assign_logo" />
                    </SimpleButton>
                </div>
                <div class="add_company_div">
                    <SimpleButton :buttonStyle="`linear-gradient(45deg, #f0f4ff, #fafdff)`" @click="agregarCompania"
                        class="button_analyst_assign add_company">
                        <span class="assign_text">Agregar Compañia</span> <img :src="NewCompany" class="assign_logo" />
                    </SimpleButton>
                </div>
            </div>
            <div class="container-table table-with-button">
                <b-table :data="sortedData" :loading="this.tableData.loading" ref="table" :total="this.numberRegisters"
                    :show-detail-icon="false">
                    <template #empty>
                        <div class="has-text-centered">
                            No hay cartera de clientes para mostrar
                        </div>
                    </template>
                    <b-table-column field="company_rut" cell-class="columna-panel columna-datos-empresa">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortCompanyName">
                                    Compañía
                                    <span class="sortButton">{{ orderMsg['company_name'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <button class="rut_button" @click="openCompany(row)">
                                <span
                                    :class="{ 'company-name': true, 'highlight-class': row.username === analystName }">
                                    {{ row.company_name }}
                                </span>
                            </button>
                        </template>
                    </b-table-column>
                    <b-table-column field="company_type" cell-class="columna-panel columna-tipo-empresa">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortCompanyType">
                                    Tipo
                                    <span class="sortButton">{{ orderMsg['company_type'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <span
                                :class="[row.company_type, 'company-type', { 'highlight-class': row.username === analystName }]">
                                {{ row.company_type }}
                            </span>
                        </template>
                    </b-table-column>
                    <b-table-column field="username" cell-class="columna-panel columna-analista">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortAnalista">
                                    Analista
                                    <span class="sortButton">{{ orderMsg['nombre'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <span :class="{ 'analyst-name': true, 'highlight-class': row.username === analystName }">
                                {{ row.nombre }}
                            </span>
                        </template>
                    </b-table-column>
                    <b-table-column field="data_completion" cell-class="columna-panel columna-estado-empresa">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortStatus">
                                    Estado
                                    <span class="sortButton">{{ orderMsg['completion'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <div class="columns is-multiline m-0" style="pointer-events: none">
                                <div class="column is-12 p-0">
                                    <b-field>
                                        <b-checkbox v-model="row.company_has_sii_fintoc" class="has-text-black ">
                                            Tiene SII fintoc
                                        </b-checkbox>
                                    </b-field>
                                </div>
                                <div class="column is-12 p-0">
                                    <b-field>
                                        <b-checkbox v-model="row.company_has_account_plans" class="">
                                            {{ row.company_n_account_plans }} Plan de cuentas
                                        </b-checkbox>
                                    </b-field>
                                </div>
                                <div class="column is-12 p-0">
                                    <b-field>
                                        <b-checkbox v-model="row.company_has_categories" class="">
                                            {{ row.company_n_categories }} Categorías
                                        </b-checkbox>
                                    </b-field>
                                </div>
                            </div>

                        </template>
                    </b-table-column>
                    <b-table-column field="data_completion" cell-class="columna-panel columna-ultimo-registro">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortLastRecord">
                                    Fuentes de datos
                                    <span class="sortButton">{{ orderMsg['last_data'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <span>
                                Fuentes de datos: <b>{{ row.datasources_good }}.</b>
                            </span>
                            <span>
                                Problemas: <b>{{ row.datasources_bad }}.</b>
                            </span>
                        </template>
                    </b-table-column>
                    <b-table-column field="data_completion" cell-class="columna-panel columna-ultimo-registro">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortLastRecord">
                                    Clasificación
                                    <span class="sortButton">{{ orderMsg['last_data'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <span :id="'last_data_' + row.company_id"></span>
                        </template>
                    </b-table-column>

                </b-table>
            </div>
        </div>
    </main>
</template>

<script>
import NewCompany from "@/assets/images/new_company.svg";
import MainLayout from "@/components/layout/MainLayout";
import AddCompany from "@/components/modals/AddCompany";
import AssignAnalysts from "@/components/modals/AssignAnalysts";
import SimpleButton from "@/components/modals/SimpleButton";


import { getCarteraAnalista, getDetalleCompania } from "@/api/carteraAnalista";

let count = 0;

export default {
    name: "PanelAnalista",
    components: {
        MainLayout,
        SimpleButton,
    },
    data() {
        return {
            NewCompany: NewCompany,
            publicPath: "http://" + window.location.hostname,
            analystName: '',
            carteraClientes: [],
            indexPerId: {},
            tableData: {
                loading: true,
                page: 0,
            },
            numberRegisters: 0,
            sortColumn: null,
            sortDirection: null,
            orderMsg: {
                'nombre': '↕',
                'company_rut': '↕',
                'company_name': '↕',
                'bigger_email': '↕',
                'company_type': '↕',
                'completion': '↕',
                'last_data': '↕',
            },
            modalDefaultUpdateSheet: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
        };
    },
    mounted() {
        this.loadData();
    },
    computed: {
        assign_logo: function () { return `${this.publicPath}/assign.png` },
        sortedData() {
            if (!this.sortColumn) {
                return this.carteraClientes;
            }
            return [...this.carteraClientes].sort((a, b) => {
                var aval = a[this.sortColumn];
                var bval = b[this.sortColumn];
                aval = String(aval).toLowerCase();
                bval = String(bval).toLowerCase();
                if (aval < bval) {
                    return this.sortDirection === 'asc' ? -1 : 1;
                }
                if (aval > bval) {
                    return this.sortDirection === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
    },
    methods: {
        loadData() {
            getCarteraAnalista().then((response) => {
                const data = response.data;
                this.analystName = data.analystName;
                this.numberRegisters = data.count;
                this.tableData.loading = false;
                this.carteraClientes.push(...data.objects);
                this.processCompanies(data.objects);
            });
        },
        agregarCompania() {
            console.log('agregando compania');
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: AddCompany,
                events: {
                    close: () => {
                        this.loadData();
                    }
                },
                onCancel: () => {
                    this.loadData();
                },
                onClose: () => {
                    this.loadData();
                }
            });
        },
        asignarAnalistas() {
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: AssignAnalysts,
                events: {
                    close: () => {
                    }
                },
            });
        },
        async processCompanies(objects) {
            var index = 0;
            for (const company of objects) {
                this.indexPerId[company.company_id] = index;
                try {
                    const resp = await getDetalleCompania(company.company_id, false);
                    this.updateCompany(resp, index);
                } catch (error) {
                    console.error('Error fetching company details:', error);
                }
                await this.delay(100);
                index++;
            }
        },
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        sum_ds(datasources, hasProblems) {
            let total = 0;
            if (datasources) {
                for (let i = 0; i < datasources.length; i++) {
                    const ds = datasources[i];
                    if (ds.problems == hasProblems) {
                        total++;
                    }
                }
            }
            // console.log(hasProblems, 'total:', total);
            return total;
        },
        updateCompany(resp, index) {
            this.$set(this.carteraClientes[index], 'file_data', resp.data['file_data']);
            this.$set(this.carteraClientes[index], 'completion', resp.data['completion']);
            this.$set(this.carteraClientes[index], 'company_contact', resp.data['bigger_email']);
            this.$set(this.carteraClientes[index], 'bigger_email', resp.data['bigger_email']);
            this.$set(this.carteraClientes[index], 'datasources_good', this.sum_ds(resp.data['datasources'], false));
            this.$set(this.carteraClientes[index], 'datasources_bad', this.sum_ds(resp.data['datasources'], true));
            this.$set(this.carteraClientes[index], 'company_type', resp.data['company_type']);
            // this.carteraClientes[index]['file_data'] = resp.data['file_data'];
            // this.carteraClientes[index]['completion'] = resp.data['completion'];
            // this.carteraClientes[index]['company_contact'] = resp.data['bigger_email'];
            // this.carteraClientes[index]['bigger_email'] = resp.data['bigger_email'];
            // this.carteraClientes[index]['datasources_good'] = this.sum_ds(resp.data['datasources'], false)
            // this.carteraClientes[index]['datasources_bad'] = this.sum_ds(resp.data['datasources'], true)
            // this.carteraClientes[index]['company_type'] = resp.data['company_type'];
        },
        resetMsgs() {
            for (var key in this.orderMsg) {
                this.orderMsg[key] = '↕';
            }
        },
        changeOrderGeneric(column) {
            if (this.sortColumn != column) {
                count = 0;
                this.sortColumn = column;
            }
            count = (count + 1) % 3;
            this.resetMsgs();
            if (count == 0) {
                this.sortColumn = null;
                this.orderMsg[column] = '↕'
            } else if (count == 1) {
                this.sortColumn = column;
                this.sortDirection = 'asc';
                this.orderMsg[column] = '↑';
            } else if (count == 2) {
                this.sortColumn = column;
                this.sortDirection = 'desc';
                this.orderMsg[column] = '↓';
            }
        },
        changeSortAnalista() {
            this.changeOrderGeneric('nombre');
        },
        changeSortCompanyRut() {
            this.changeOrderGeneric('company_rut');
        },
        changeSortCompanyName() {
            this.changeOrderGeneric('company_name');
        },
        changeSortCompanyContact() {
            this.changeOrderGeneric('bigger_email');
        },
        changeSortCompanyType() {
            this.changeOrderGeneric('company_type');
        },
        changeSortStatus() {
            this.changeOrderGeneric('completion');
        },
        changeSortLastRecord() {
            this.changeOrderGeneric('last_data');
        },
        openCompany(companySelected) {
            this.$router.push({
                name: "companyData",
                query: {
                    companyId: companySelected.company_id,
                    companyRut: companySelected.company_rut
                },
            })
        },
        onSectionChange(section, tab) {
            // PanelAnalista no es una sección del sidebar — cualquier click
            // en el rail navega al Dashboard con el query correspondiente.
            // El route name del dashboard depende del client_type del user;
            // usamos path para no atarnos a ese enum.
            const query = { section };
            if (tab) query.tab = tab;
            this.$router.push({ path: "/dashboard", query }).catch((err) => {
                if (err.name !== "NavigationDuplicated") throw err;
            });
        },
    },
}
</script>
<style scoped>
.highlight-class {
    font-weight: bold !important;
}

.rut_button {
    border-radius: 1px;
    border: 0;
    padding: 2px 5px;
    background-image: linear-gradient(225deg, #f5f5f5, #fafafa);
    white-space: nowrap;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}

.rut_button:hover {
    transform: translateY(-2px);
    filter: drop-shadow(-1px 1px 3px #d0d0d0ff);
}

.rut_button:active {
    transform: translateY(1px);
}

.sortButton {
    border: none;
    background-color: none;
    font-weight: bold;
    -webkit-text-stroke: 1.3px #000;
}

.sortButtonLabel {
    border-radius: 1px;
    padding: 2px 5px;
    background-image: linear-gradient(135deg, #f0f0f0, #fafafa);
    white-space: nowrap;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}

.sortButtonLabel:hover {
    transform: translateY(-2px);
    filter: drop-shadow(-1px 1px 2px #d0d0d0ff);
}

.sortButtonLabel:active {
    transform: translateY(1px);
}

.table-with-button {
    /* width: 90%;*/
    align-items: center !important;
}

.subheadings {
    user-select: none;
    white-space: nowrap;
}

div .header-title {
    user-select: none;
    white-space: nowrap;
}

.company-type.BASIC {
    color: blue;
}

.company-type.SPOT,
.company-type.SPOT-CON {
    color: green;
}

.company-type.ENTERPRISE {
    color: red;
}

.company-type.SECONDARY {
    color: orange;
}

.company-type.CLASSIC {
    color: purple;
}

.company-type.ESSENTIAL {
    color: grey;
}

.company-rut {
    font-style: italic;
}

.company-name {
    overflow-wrap: break-word;
}

.columna-tipo-empresa {
    background-color: #f00;
}

.assign_logo {
    height: 32px;
    margin-top: 0px;
}

.assign_text {
    font-size: 16px;
    position: relative;
}

.centered_div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 20px;
    margin-bottom: 10px;
}

.analyst_assign_div {
    flex: 0;
    margin: 0 auto;
}

.add_company_div {
    flex: 0;
    margin-left: auto;
}

.button_analyst_assign {
    width: 200px;
    min-width: 200px;
    height: 50px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    line-height: normal;
}

</style>
<style>
.columna-analista {
    white-space: break-spaces !important;
    max-width: 100px !important;
}

.columna-tipo-empresa {
    max-width: 100px !important;
}

.columna-datos-empresa {
    max-width: 200px !important;
    width: 200px;
}

.columna-estado-empresa {
    max-width: 410px !important;
    min-width: 180px;
}

.columna-ultimo-registro {
    max-width: 100px !important;
}

.columna-panel {
    text-align: center !important;
}

.table-with-button td,
.table th {
    padding: 0px !important;
}

.table-with-button span:nth-child(1) {
    margin: auto;
}

.table-with-button th {
    text-align: center !important;
}

.table-with-button th:nth-child(1) {
    width: 7em;
    max-width: 150px;
    text-align: center !important;
}

.table-with-button th:nth-child(2) {
    width: 9em;
    max-width: 100px;
}

.table-with-button th:nth-child(3) {
    width: 19em;
    max-width: 250px;
}

.table-with-button th:nth-child(4) {
    width: 7em;
    max-width: 540px;
}

.table-with-button th:nth-child(5) {
    width: 11em;
    max-width: 150px;
}

.table-with-button .b-table .table {
    width: 98%;
}

.table tbody {
    background-image: linear-gradient(135deg, #fefefe, #fafafa);
    border-radius: 2px;
}

.noborders td {
    border: 0 !important;
}
</style>